var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "dialog-actions-container" },
    [
      _c("LfActionsBarComponent", {
        staticClass: "action-buttons",
        attrs: { buttons: _vm.buttons, showKebabMenu: false },
        on: { "execute-action": _vm.executeAction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }